<template>
  <div class="layout-wrapper">
    <!--side-->
    <layout-sidebar />
    <!--main-->
    <layout-content />
  </div>
</template>

<script>
import LayoutSidebar from './LayoutSidebar';
import LayoutContent from './LayoutContent';

export default {
  components: {
    LayoutSidebar,
    LayoutContent,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/LayoutMain.vue